import { render, staticRenderFns } from "./ChartRunningSpeedCadenceDetailled.vue?vue&type=template&id=54be747c&scoped=true&"
import script from "./ChartRunningSpeedCadenceDetailled.vue?vue&type=script&lang=ts&"
export * from "./ChartRunningSpeedCadenceDetailled.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54be747c",
  null
  
)

export default component.exports